import {ReactElement} from 'react'
import {Trans} from 'react-i18next'

import {useStyles} from './styles'
import messages from '../../../../assets/messages'

function PammInvestorAccountMessage(): ReactElement {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Trans {...messages.importantInformation} />
      </div>
      <div className={classes.body}>
        <ul className={classes.list}>
          <li><Trans {...messages.yourWithdrawalRequestWillBeSentToYourMoneyManager} /></li>
          <li><Trans {...messages.onceApprovedTheFundsWillBeCredited} /></li>
          <li><Trans {...messages.ifYourMoneyManagerDeclinesTheRequest} /></li>
        </ul>
      </div>
    </div>
  )
}

export {PammInvestorAccountMessage}
